import { io } from "socket.io-client";
import { API_BASE } from "../components/config";

const storedToken = localStorage.getItem('token');

// Production (Passenger / reverse proxy) works more reliably when WebSocket
// is attempted first. Polling remains available for networks that block it.
const connectionOptions = {
  transports: ['websocket', 'polling'],
  tryAllTransports: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 15000
};

const socket = io(API_BASE, {
  ...connectionOptions,
  autoConnect: Boolean(storedToken),
  auth: { token: storedToken }
});

// A token may have changed after login while the singleton socket already
// existed. Always attach the newest token before a reconnect attempt.
socket.io.on('reconnect_attempt', () => {
  socket.auth = { token: localStorage.getItem('token') };
});

socket.on("connect", () => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket connected:', socket.id);
  }
});

socket.on("disconnect", (reason) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Socket disconnected:', reason);
  }
});

socket.on('connect_error', error => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Socket connection error:', error.message);
  }

  if (['Invalid token', 'No token'].includes(error.message)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    socket.disconnect();

    if (window.location.pathname !== '/') {
      window.location.assign('/');
    }
  }
});

export function connectSocket(token = localStorage.getItem('token')) {
  if (!token) return;
  socket.auth = { token };
  if (!socket.connected) socket.connect();
}

export function disconnectSocket() {
  socket.disconnect();
}

export function createMonitorSocket() {
  return io(API_BASE, {
    ...connectionOptions,
    auth: { monitor: true },
  });
}

export default socket;
